import axios from "axios";
import { deleteToken, getToken } from "./usuario";
import Swal from "sweetalert2";


const env = process.env.REACT_APP_CURRENT_ENV;
//const url = env == "dev" ? 'http://192.168.100.241:9020/api' : process.env.REACT_APP_URL_PRD;; //CERT
const url = env == "dev" ? 'http://192.168.100.178:8010/api' : process.env.REACT_APP_URL_PRD;; //NEWPRE

const clienteAxiosAux = axios.create({ baseURL: url });

export let sessionExpiredAlertShown = false;

export const resetSessionExpiredAlert = () => {
  sessionExpiredAlertShown = false;
};

clienteAxiosAux.interceptors.request.use(
  function (config) {
    const token = getToken();
    config.headers["authorization"] = `Bearer ${token}`;
    return config;
  },
  function (error) {
    if (error.response.status === 401) {
      deleteToken();
      window.location = "/login";
    }
    return Promise.reject(error);
  }
);

clienteAxiosAux.interceptors.response.use(
  function (response) {
    if (response.data.codigo === 401 && !sessionExpiredAlertShown) {
      sessionExpiredAlertShown = true;

      Swal.fire({
        icon: "error",
        title: "Error",
        html: `<p>Por favor, vuelve a ingresar tus datos de acceso.</p>`,
        confirmButtonText: "OK",
        focusConfirm: false,
        iconColor: "red",
        width: "40rem",
        customClass: {
          popup: "containerSwal",
          title: "titleSwal",
          closeButton: "...",
          icon: "iconSwal",
          confirmButton: "buttonSwal",
          denyButton: "...",
          cancelButton: "...",
        },
      }).then(() => {
        deleteToken();
        window.location = "/login";
      });
    }
    return response;
  },

  function (error) {
    if (error.response.status === 401) {
      deleteToken();
      window.location = "/login";
    } else {
      return Promise.reject(error);
    }
  }
);

export default clienteAxiosAux;
